import React, { useState } from 'react';

export const Navigation = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-2'
            onClick={handleMenuClick}
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='/'>
            <img style={{ height: 40, overflow: 'hidden', }} align="left" src="/logo.png" alt='best ro-repair service' />
            <p style={{ display: "inline-block", fontSize: '20px', marginBottom: '2px', marginTop: '10px' }}>&nbsp; RO Care Solution</p>
            {/* <p style={{ fontSize: '9px' }}>&nbsp; Fixing the Impossible, Just for You!</p> */}
          </a>{' '}
        </div>

        <div
          className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a className="btn" href="mailto: homeservesindia@gmail.com" ><i className="fa fa-envelope" style={{fontSize :"12px"}}> </i> homeservesindia@gmail.com</a>
            </li>
            
            <li>

              <a className="btn" href="tel:9960095385" ><i className="fa fa-phone" style={{fontSize :"12px"}}> +91-9960095385</i></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
